<template>
  <div>
    <v-layout wrap>
      <v-flex xs12 mt-6>
        <v-text-field v-model="query" label="Chercher un utilisateur par : Nom, Email, nom d'Entreprise ou id d'Entreprise." dense outlined prepend-inner-icon="mdi-magnify"/>
        <div class="text-end">
          <small>{{ usersToDisplay.length }} résultats.</small>
        </div>
      </v-flex>
      <v-flex xs12 v-for="(user, key) in usersToDisplay" :key="key">
        <v-card class="mb-8 py-4 px-4">
          <v-layout wrap>
            <v-flex xs8>
              <small>
                <div>
                  <div><b>{{ [user.firstName, user.lastName].filter(x => !!x).join(' ') }}</b></div>
                  <div v-if="user.companyName">
                    <b>{{ user.companyName }}</b>
                    <small class="ml-1">(id : {{ user.companyId }})</small>
                  </div>
                  <div v-else>
                    <div v-if="user.isConsultant">
                      Cet utilisateur est un <b>consultant</b>
                    </div>
                    <div v-else class="red--text">
                      <b>❌ N'a pas d'entreprise.</b>
                    </div>
                  </div>
                  <div><b>{{ user.email }}</b></div>
                </div>
                <div>
                  <div v-if="!user.isEmailVerified">
                    <span class="red--text mr-2">❌ Adresse email non vérifiée.</span>
                    <span class="textAsLink" @click="showVerifyUserEmailAddressManuallyDialog(user)">Valider son adresse email manuellement</span>
                  </div>
                  <div v-if="user.role">Role : {{ user.role.charAt(0).toUpperCase() + user.role.slice(1) }}</div>
                  <div v-if="user.isParentCompanyAdmin"><b>Admin du groupe parent de sa BU.</b></div>
                  <div>{{ user.phoneNumber }}</div>
                  <div>Compte créé le {{ new Date(user.createdAt).toLocaleDateString() }}.</div>
                </div>
                <div class="mt-2">
                  <div v-if="Number.isInteger(user.dossiersNbCreated)">
                    <div>{{ user.dossiersNbCreated }} dossiers créés.</div>
                  </div>
                  <div v-else-if="user.hasMoreUserDetailsOrIsFetching">
                    <!-- <v-progress-linear indeterminate/> -->
                  </div>
                  <div v-else>
                    <a @click="getMoreUserDetails(user.id)" class="textAsLink">Voir le nombre de dossiers créés par cet utilisateur</a>
                  </div>
                </div>
              </small>
            </v-flex>
            <v-flex xs4 text-end>
              <v-btn v-if="user.isEmailVerified" @click="impersonate(user.id)" class="primary mt-7 mr-6" small>
                Impersonate
              </v-btn>

              <v-btn @click="showDeleteUserDialog(user)" outlined  class="mt-7" small>Delete user</v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="isImpersonatePending" width="50%" persistent>
      <v-card class="pa-6">
        <div><b>Impersonation en cours...</b></div>
        <v-progress-linear indeterminate color="primary" class="mt-3"></v-progress-linear>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isShowingVerifyUserEmailAddressManuallyDialog" width="50%">
      <v-card v-if="userForVerifyUserEmailAddressManually" class="pa-6">
        <div><b>Valider l'adresse email de {{ userForVerifyUserEmailAddressManually.email }} ?</b></div>
        <div class="mt-6">
          <v-layout wrap>
            <v-flex xs6 text-center>
              <v-btn small class="primary" @click="verifyUserEmailAddressManually">Valider son adresse email</v-btn>
            </v-flex>
            <v-flex xs6 text-center>
              <v-btn small outlined @click="isShowingVerifyUserEmailAddressManuallyDialog=false">Annuler</v-btn>
            </v-flex>
          </v-layout>
        </div>
      </v-card>
    </v-dialog>


    <v-dialog v-model="isVerifyUserEmailAddressManuallyPending" width="50%" persistent>
      <v-card class="pa-6">
        <div><b>Validation de l'adresse email en cours...</b></div>
        <i>Rafraichir la page après pour s'assurer que ça a marché.</i>
        <v-progress-linear indeterminate color="primary" class="mt-3"></v-progress-linear>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isShowingDeleteUserDialog" width="50%" :persistent="isDeleteUserPending">
      <v-card class="pa-6">
        <div v-if="!isDeleteUserPending">
          <h3 class="mb-4">Supprimer l'utilisateur ?</h3>
          <div v-if="userForDelete">
            <div><b>{{ [userForDelete.firstName, userForDelete.lastName].filter(Boolean).join(' ') }}</b> ({{ userForDelete.email }})</div>
          </div>
          <div v-if="deleteUserErrorMsg" class="red--text mt-2">{{ deleteUserErrorMsg }}</div>
          <v-layout wrap mt-4>
            <v-flex xs6 text-center>
              <v-btn small class="error" @click="deleteUser">Supprimer</v-btn>
            </v-flex>
            <v-flex xs6 text-center>
              <v-btn small outlined @click="isShowingDeleteUserDialog = false">Annuler</v-btn>
            </v-flex>
          </v-layout>
        </div>
        <div v-else>
          <v-progress-linear indeterminate color="primary" class="mt-3"></v-progress-linear>
        </div>
      </v-card>
    </v-dialog>

  </div>  
</template>

<script>
export default {
  props: {
    allUsers: Array
  },
  data: () => ({
    isImpersonatePending: false,
    query: "",
    userForVerifyUserEmailAddressManually: null,
    isVerifyUserEmailAddressManuallyPending: false,
    isShowingVerifyUserEmailAddressManuallyDialog: false,
    isShowingDeleteUserDialog: false,
    userForDelete: null,
    isDeleteUserPending: false,
    deleteUserErrorMsg: null
  }),
  mounted() {
    this.initGetMoreUserDetailsForTopUsers()
    if (this.$route.query.userQuery) this.query = this.$route.query.userQuery
  },
  computed: {
    usersToDisplay() {
      return this.allUsers.filter(item => {
        return [item.companyId, item.firstName, item.lastName, item.companyName, item.email].filter(x => !!x).join(' ').toLocaleLowerCase().indexOf(this.query.toLocaleLowerCase()) > -1
      }).sort((a,b) => b.createdAt > a.createdAt ? 1 : -1)
    },
    topUserIdsToDisplay() {
      return this.usersToDisplay.slice(0, 5).map(user => user.id);
    }
  },
  methods: {
    async impersonate(userId) {
      this.isImpersonatePending = true
      const token = (await this.$functions.httpsCallable('impersonate')({
        userId
      })).data
      await this.$auth.signInWithCustomToken(token)
      this.$router.go()
    },
    getMoreUserDetails(userId) {
      this.allUsers.find(user => user.id === userId).hasMoreUserDetailsOrIsFetching = true
      this.$emit('getMoreUserDetails', { userId })
    },
    initGetMoreUserDetailsForTopUsers() {
      this.query = ' '
      setTimeout(() => {
        this.query = ''
      }, 1)
    },
    showVerifyUserEmailAddressManuallyDialog(user) {
      this.userForVerifyUserEmailAddressManually = user
      this.isShowingVerifyUserEmailAddressManuallyDialog = true
    },
    showDeleteUserDialog(user) {
      this.userForDelete = user;
      this.isShowingDeleteUserDialog = true;
      this.deleteUserErrorMsg = null;
    },
    async verifyUserEmailAddressManually() {
      this.isVerifyUserEmailAddressManuallyPending = true
      await this.$functions.httpsCallable('verifyUserEmailAddressManually')({ userId: this.userForVerifyUserEmailAddressManually.id })
      this.isShowingVerifyUserEmailAddressManuallyDialog = false
      this.isVerifyUserEmailAddressManuallyPending = false
    },
    async deleteUser() {
      this.isDeleteUserPending = true;
      this.deleteUserErrorMsg = null;
      try {
        await this.$functions.httpsCallable('deleteUser')({ userId: this.userForDelete.id });
        this.isShowingDeleteUserDialog = false;
        this.userForDelete = null;
        this.$router.go();
      } catch (err) {
        this.deleteUserErrorMsg = err.message || 'Erreur lors de la suppression.';
      } finally {
        this.isDeleteUserPending = false;
      }
    }
  },
  watch: {
    topUserIdsToDisplay: {
      handler() {
        this.allUsers.filter(user => this.topUserIdsToDisplay.includes(user.id) && !user.hasMoreUserDetailsOrIsFetching && !user.dossiersNbCreated).forEach(user => {
          this.getMoreUserDetails(user.id)
        });
      },
    },
    isShowingVerifyUserEmailAddressManuallyDialog: {
      handler(val, oldVal) {
        if (!val && oldVal) {
          this.userForVerifyUserEmailAddressManually = null
        }
      }
    },
    isShowingDeleteUserDialog: {
      handler(val, oldVal) {
        if (!val && oldVal) {
          this.userForDelete = null;
          this.deleteUserErrorMsg = null;
        }
      }
    }
  }
}
</script>
